export default __webpack_public_path__ + "static/media/Cellphonegirl.753460fe.png";